import { Outlet } from "react-router-dom";
import './Gallery.css';

function Gallery() {
    return (
      <div className="Gallery_Container">
        <Outlet />
      </div>
    );
  }
  
  export default Gallery;
